import React from 'react';
import { useNavigate } from 'react-router-dom';

const ROUTES = [
  { from: 'DEL', to: 'BOM', fromCity: 'Delhi',     toCity: 'Mumbai',    price: 2499, duration: '2h 15m', gradient: 'from-violet-600 to-purple-700', img: '🏙️' },
  { from: 'BLR', to: 'DEL', fromCity: 'Bangalore', toCity: 'Delhi',     price: 3199, duration: '2h 45m', gradient: 'from-amber-500 to-orange-500',  img: '🕌' },
  { from: 'BOM', to: 'GOI', fromCity: 'Mumbai',    toCity: 'Goa',       price: 1899, duration: '1h 20m', gradient: 'from-purple-600 to-violet-700', img: '🏖️' },
  { from: 'DEL', to: 'BLR', fromCity: 'Delhi',     toCity: 'Bangalore', price: 2999, duration: '2h 55m', gradient: 'from-violet-700 to-indigo-600', img: '🌿' },
  { from: 'MAA', to: 'BOM', fromCity: 'Chennai',   toCity: 'Mumbai',    price: 2799, duration: '2h 00m', gradient: 'from-amber-600 to-yellow-500',  img: '🌊' },
  { from: 'HYD', to: 'CCU', fromCity: 'Hyderabad', toCity: 'Kolkata',   price: 3499, duration: '2h 20m', gradient: 'from-purple-500 to-violet-600', img: '🎭' },
];

export default function PopularRoutes() {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <span className="inline-block text-xs font-bold text-violet-600 uppercase tracking-widest bg-violet-50 border border-violet-100 px-4 py-1.5 rounded-full mb-3">
            Most Booked Routes
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-2">Popular Flights</h2>
          <p className="text-gray-500 text-sm sm:text-base">Thousands of travelers fly these routes every day — at unbeatable fares</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {ROUTES.map(route => (
            <div
              key={route.from + route.to}
              onClick={() => navigate('/flights?origin=' + route.from + '&destination=' + route.to + '&date=' + today + '&adults=1&tripType=oneway&class=economy&passengers=1')}
              className={'group bg-gradient-to-br ' + route.gradient + ' rounded-2xl p-5 sm:p-6 text-white cursor-pointer hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden'}
            >
              <div className="absolute right-4 top-4 text-5xl sm:text-6xl opacity-10 select-none">{route.img}</div>
              <div className="relative z-10">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="text-3xl font-black">{route.from}</p>
                    <p className="text-white/70 text-xs mt-0.5">{route.fromCity}</p>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <div className="flex items-center gap-1 w-20">
                      <div className="h-px flex-1 bg-white/40" />
                      <span className="text-sm">✈</span>
                      <div className="h-px flex-1 bg-white/40" />
                    </div>
                    <span className="text-white/50 text-xs">{route.duration}</span>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-black">{route.to}</p>
                    <p className="text-white/70 text-xs mt-0.5">{route.toCity}</p>
                  </div>
                </div>
                <div className="flex items-center justify-between pt-3 border-t border-white/20">
                  <div>
                    <p className="text-xs text-white/60">Starting from</p>
                    <p className="text-2xl font-black">{'₹' + route.price.toLocaleString('en-IN')}</p>
                  </div>
                  <span className="bg-white/15 border border-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-xl group-hover:bg-white group-hover:text-violet-700 transition-all">
                    Search →
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
